module.exports = __webpack_public_path__ + "static/img/place_2.d50dcb7c.png";